"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorIcon = function ErrorIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "64px", height: "64px", viewBox: "0 0 64 64", version: "1.1" },
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { id: "Group-3-Copy" },
        _react2.default.createElement("rect", {
          fill: "#FFFFFF",
          x: "0",
          y: "0",
          width: "64",
          height: "64"
        }),
        _react2.default.createElement(
          "g",
          { id: "Group-9", transform: "translate(14.000000, 15.000000)" },
          _react2.default.createElement("polygon", { fill: "#636665", points: "18 0 36 32 0 32" }),
          _react2.default.createElement("rect", {
            fill: "#FFFFFF",
            fillRule: "nonzero",
            x: "17",
            y: "10",
            width: "2",
            height: "12"
          }),
          _react2.default.createElement("rect", {
            fill: "#FFFFFF",
            fillRule: "nonzero",
            x: "17",
            y: "25",
            width: "2",
            height: "3"
          })
        )
      )
    )
  );
};

exports.default = ErrorIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamError/ErrorIcon.js
// module id = 532
// module chunks = 11